import { render, staticRenderFns } from "./ListCompanyRoom.vue?vue&type=template&id=3bf72582&"
import script from "./ListCompanyRoom.vue?vue&type=script&lang=js&"
export * from "./ListCompanyRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports